import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '@angular/material';
import { DataTableModule, SharedModule } from 'primeng/primeng';

import { PendingTransactionsOverviewComponent } from './pending-transactions-overview.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MaterialModule.forRoot(),
    DataTableModule,
    SharedModule
  ],
  declarations: [
    PendingTransactionsOverviewComponent
  ],
  exports: [
    PendingTransactionsOverviewComponent
  ]
})
export class PendingTransactionsOverviewModule { }



// WEBPACK FOOTER //
// ./src/app/finance/pending-transactions-overview/pending-transactions-overview.module.ts